<template>
    <div>
        <div v-if="updateMsg" class="text-green">{{ updateMsg }}</div>

          <div class="text-center pt-4" v-if="loading == true">
            <div class="row ml-1" v-for="option in 10">
              <div class="res_heading_1" style=" padding-left: 0px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="res_heading_2" style=" padding-left: 10px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-12 p-0">
                <div class="custom_hr"></div>
              </div>
            </div>
          </div>


        <div v-if="show_more_tasklists === false && accountTaskListsCount > 0">
            <div class="col-12 override-padding">
                <div class="res_offcanvas_header res_heading_1 text-left">
                    Task Lists
                    <a href="javascript:void(0)" class="see-more branding_text_color" v-if="accountTaskListsCount > 3 && accountTaskListsCount > 0" @click="showMoreTaskLists"> - {{see_more_tasklists_text}}</a>
                </div>

                <div class="res_offcanvas_header res_heading_2 text-center"># of Users</div>
                <div class="clearfix"></div>

                <div class="col-12 resources_lists" v-for="(item, uindex) in lessAccountTaskLists" :key="uindex">
                    <div class="res_offcanvas_content res_heading_1 text-left">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        {{ item.name }}
                      </div>
                    </div>
                        
                    </div>
                    <div class="res_offcanvas_content res_heading_2 text-center">
                        {{ item.userCount }}
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        <div v-if="show_more_tasklists === true && accountTaskListsCount > 0">
            <div class="col-12 override-padding">
                <div class="res_offcanvas_header res_heading_1 text-left">
                    Task Lists
                    <a href="javascript:void(0)" class="see-more branding_text_color" v-if="accountTaskListsCount > 3 && accountTaskListsCount > 0" @click="showMoreTaskLists"> - {{see_more_tasklists_text}}</a>
                </div>
                <div class="res_offcanvas_header res_heading_2 text-center"># of Users</div>
                <div class="clearfix"></div>

                <div class="col-12 resources_lists" v-for="(item, uindex) in accountTaskLists" :key="uindex">
                    <div v-if="readOnly" class="res_offcanvas_content res_heading_1 text-left">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        {{ item.name }}
                      </div>
                    </div>
                    </div>
                    <div v-else class="res_offcanvas_content res_heading_1 text-left">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        {{ item.name }}
                      </div>
                    </div>
                    </div>
                    <div class="res_offcanvas_content res_heading_2 text-center">
                        {{ item.userCount }}
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        <div v-if="accountTaskListsCount === 0 && loading == false">
            <div class="font-weight-bold">
                Task Lists
                <div class="row_item_readonly justify-content-md-center">
                    <div class="text-red text-center m-4">{{ getNoRecordText(accountTaskListsCount, 'Task Lists') }}</div>
                </div>
            </div>
        </div>
        <div v-if="show_more_courses === false && accountCoursesCount > 0">
            <div class="col-12 override-padding">
                <div class="res_offcanvas_header res_heading_1 text-left">
                    Courses
                    <a href="javascript:void(0)" class="see-more branding_text_color" v-if="accountCoursesCount > 3 && accountCoursesCount > 0" @click="showMoreCourses"> - {{see_more_courses_text}}</a>
                </div>
                <div class="res_offcanvas_header res_heading_2 text-center"># of Users</div>
                <div class="clearfix"></div>

                <div class="col-12 resources_lists" v-for="(item, coindex) in lessAccountCourses" :key="coindex">
                    <div v-if="readOnly" class="res_offcanvas_content res_heading_1 text-left">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        {{ item.name }}
                      </div>
                    </div>
                    </div>
                    <div v-else class="res_offcanvas_content res_heading_1 text-left">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        {{ item.name }}
                      </div>
                    </div>
                    </div>
                    <div class="res_offcanvas_content res_heading_2 text-center">
                        {{ item.userCount }}
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        <div v-if="show_more_courses === true && accountCoursesCount > 0">
            <div class="col-12 override-padding">
                <div class="res_offcanvas_header res_heading_1 text-left">
                    Courses
                    <a href="javascript:void(0)" class="see-more branding_text_color" v-if="accountCoursesCount > 3 && accountCoursesCount > 0" @click="showMoreCourses"> - {{see_more_courses_text}}</a>
                </div>
                <div class="res_offcanvas_header res_heading_2 text-center"># of Users</div>
                <div class="clearfix"></div>


                <div class="col-12 resources_lists" v-for="(item, uindex) in accountCourses" :key="uindex">
                    <div v-if="readOnly" class="res_offcanvas_content res_heading_1 text-left">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        {{ item.name }}
                      </div>
                    </div>
                    </div>
                    <div v-else class="res_offcanvas_content res_heading_1 text-left">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        {{ item.name }}
                      </div>
                    </div>
                    </div>
                    <div class="res_offcanvas_content res_heading_2 text-center">
                        {{ item.userCount }}
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        <div v-if="accountCoursesCount === 0 && loading == false">
            <div class="font-weight-bold">
                Courses
                <div class="row_item_readonly justify-content-md-center">
                    <div class="text-red text-center m-4">{{ getNoRecordText(accountCoursesCount, 'Courses') }}</div>
                </div>
            </div>
        </div>
        <div v-if="show_more_assessments === false && accountAssessmentsCount > 0">
            <div class="col-12 override-padding">
                <div class="res_offcanvas_header res_heading_1 text-left">
                    Assessments
                    <a href="javascript:void(0)" class="see-more branding_text_color" v-if="accountAssessmentsCount > 3 && accountAssessmentsCount > 0" @click="showMoreAssessments"> - {{see_more_assessments_text}}</a>
                </div>
                <div class="res_offcanvas_header res_heading_2 text-center"># of Users</div>
                <div class="clearfix"></div>


                <div class="col-12 resources_lists" v-for="(item, aindex) in lessAccountAssessments" :key="aindex">
                    <div v-if="readOnly" class="res_offcanvas_content res_heading_1 text-left">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        {{ item.name }}
                      </div>
                    </div>
                    </div>
                    <div v-else class="res_offcanvas_content res_heading_1 text-left">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        {{ item.name }}
                      </div>
                    </div>
                    </div>
                    <div class="res_offcanvas_content res_heading_2 text-center">
                        {{ item.userCount }}
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        <div v-if="show_more_assessments === true && accountAssessmentsCount > 0">
            <div class="col-12 override-padding">
                <div class="res_offcanvas_header res_heading_1 text-left">
                    Assessments
                    <a href="javascript:void(0)" class="see-more branding_text_color" v-if="accountAssessmentsCount > 3 && accountAssessmentsCount > 0" @click="showMoreAssessments"> - {{see_more_assessments_text}}</a>
                </div>
                <div class="res_offcanvas_header res_heading_2 text-center"># of Users</div>
                <div class="clearfix"></div>


                <div class="col-12 resources_lists" v-for="(item, aindex) in accountAssessments" :key="aindex">
                    <div v-if="readOnly" class="res_offcanvas_content res_heading_1 text-left">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        {{ item.name }}
                      </div>
                    </div>
                    </div>
                    <div v-else class="res_offcanvas_content res_heading_1 text-left">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        {{ item.name }}
                      </div>
                    </div>
                    </div>
                    <div class="res_offcanvas_content res_heading_2 text-center">
                        {{ item.userCount }}
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        <div v-if="accountAssessmentsCount === 0 && loading == false">
            <div class="font-weight-bold">
                Assessments
                <div class="row_item_readonly justify-content-md-center">
                    <div class="text-red text-center m-4">{{ getNoRecordText(accountAssessmentsCount, 'Assessment') }}</div>
                </div>
            </div>
        </div>
        <div v-if="show_more_forms === false && accountFormsCount > 0">
            <div class="col-12 override-padding">
                <div class="res_offcanvas_header res_heading_1 text-left">
                    Forms
                    <a href="javascript:void(0)" class="see-more branding_text_color" v-if="accountFormsCount > 3 && accountFormsCount > 0" @click="showMoreForms"> - {{see_more_forms_text}}</a>
                </div>
                <div class="res_offcanvas_header res_heading_2 text-center"># of Users</div>
                <div class="clearfix"></div>


                <div class="col-12 resources_lists" v-for="(item, uindex) in lessAccountForms" :key="uindex">
                    <div class="res_offcanvas_content res_heading_1 text-left">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        {{ item.name }}
                      </div>
                    </div>
                    </div>
                    <div class="res_offcanvas_content res_heading_2 text-center">
                        {{ item.userCount }}
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        <div v-if="show_more_forms === true && accountFormsCount > 0">
            <div class="col-12 override-padding">
                <div class="res_offcanvas_header res_heading_1 text-left">
                    Forms
                    <a href="javascript:void(0)" class="see-more branding_text_color" v-if="accountFormsCount > 3 && accountFormsCount > 0" @click="showMoreForms"> - {{see_more_forms_text}}</a>
                </div>
                <div class="res_offcanvas_header res_heading_2 text-center"># of Users</div>
                <div class="clearfix"></div>


                <div class="col-12 resources_lists" v-for="(item, uindex) in accountForms" :key="uindex">
                    <div class="res_offcanvas_content res_heading_1 text-left">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        {{ item.name }}
                      </div>
                    </div>
                    </div>
                    <div class="res_offcanvas_content res_heading_2 text-center">
                        {{ item.userCount }}
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        <div v-if="accountFormsCount === 0 && loading == false">
            <div class="font-weight-bold">
                Forms
                <div class="row_item_readonly justify-content-md-center">
                    <div class="text-red text-center m-4">{{ getNoRecordText(accountFormsCount, 'Form') }}</div>
                </div>
            </div>
        </div>


        <ResourcesConfirmModal 
            :isModalVisible="isResourcesConfirmModalVisible" 
            @close="isResourcesConfirmModalVisible = false"
            ref="confirmation_resources_modal">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="confirm_message">
            {{ confirmation_message }}
          </div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-12 override-padding">
            <button type="button" class="btn btn-sm cancelBtn float-left" @click="closeConfirmationAction">{{ cancelBtn }}</button>
            <button v-if="isConfirmBtn" class="btn btn-sm saveBtn float-right" @click="resourcesConfirmationAction">Confirm</button>
            <button v-if="isYesBtn" class="btn btn-sm saveBtn float-right" @click="doUpdateAssignmentAction">Yes</button>
          </div>
        </ResourcesConfirmModal>
    </div>
</template>
<script>
import axios from 'axios';
import ResourcesConfirmModal from './resources_confirm_modal.vue';
export default {
    props: ['accountId', 'readOnly'],
    data() {
        return {
            accountTaskLists: [],
            lessAccountTaskLists: [],
            accountTaskListsCount: 0,
            accountAssessments: [],
            lessAccountAssessments: [],
            accountAssessmentsCount: 0,
            accountCourses: [],
            lessAccountCourses: [],
            accountCoursesCount: 0,
            accountForms: [],
            lessAccountForms: [],
            accountFormsCount: 0,
            see_more_tasklists_text: 'See all',
            see_more_assessments_text: 'See all',
            see_more_courses_text: 'See all',
            see_more_forms_text: 'See all',
            show_more_tasklists: false,
            show_more_assessments: false,
            show_more_courses: false,
            show_more_forms: false,
            isResponseStatus: false,
            coursesSelected: [],
            assessmentsSelected: [],
            tasklistsSelected: [],
            formssSelected: [],
            confirmation_message: '',
            isResourcesConfirmModalVisible: false,
            cancelBtn: 'Cancel',
            isConfirmBtn: true,
            isYesBtn: false,
            delete_id: '',
            resource_type: '',
            confirm_all_warnings: false,
            modifiedTasklists: [],
            modifiedCourses: [],
            modifiedAssessments: [],
            removedTasklists: [],
            removedCourses: [],
            removedAssessments: [],
            updateMsg: '',
            loading: false,
        }
    },
    components: {
        ResourcesConfirmModal,
    },
    methods: {
        showMoreTaskLists() {
            if (!this.show_more_tasklists) {
                this.show_more_tasklists = true;
                this.see_more_tasklists_text = 'See less';
            } else {
                this.show_more_tasklists = false;
                this.see_more_tasklists_text = 'See all';
            }
        },
        showMoreAssessments() {
            if (!this.show_more_assessments) {
                this.show_more_assessments = true;
                this.see_more_assessments_text = 'See less';
            } else {
                this.show_more_assessments = false;
                this.see_more_assessments_text = 'See all';
            }
        },
        showMoreCourses() {
            if (!this.show_more_courses) {
                this.show_more_courses = true;
                this.see_more_courses_text = 'See less';
            } else {
                this.show_more_courses = false;
                this.see_more_courses_text = 'See all';
            }
        },
        showMoreForms() {
            if (!this.show_more_forms) {
                this.show_more_forms = true;
                this.see_more_forms_text = 'See less';
            } else {
                this.show_more_forms = false;
                this.see_more_forms_text = 'See all';
            }
        },
        getNoRecordText(count, textMsg) {
            if (this.loading) {
                return '';
            } else {
                if (count == 0 && this.isResponseStatus) {
                    return "No " + textMsg + " Found.";
                }
            }
        },
        getCourseSelected(event) {
            let cid = event.target.value;
            if(event.target.checked == true) {
               this.coursesSelected.push(cid);
               this.modifiedCourses.push(cid);
            }
            else {
                this.isResourcesConfirmModalVisible = true;
                this.delete_id = cid;
                this.resource_type = 'courses';
                this.cancelBtn = 'Cancel';
                this.confirmation_message = 'This course users will no longer have access';
            }
        },
        getAssessmentSelected(event) {
            let aid = event.target.value;
            if(event.target.checked == true) {
               this.assessmentsSelected.push(aid);
               this.modifiedAssessments.push(aid);
            }
            else {
                this.isResourcesConfirmModalVisible = true;
                this.delete_id = aid;
                this.resource_type = 'assessments';
                this.cancelBtn = 'Cancel';
                this.confirmation_message = 'This assessment users will no longer have access';
            }
        },
        getTasklistSelected(event) {
            let tid = event.target.value;
            if(event.target.checked == true) {
               this.tasklistsSelected.push(tid);
               this.modifiedTasklists.push(tid);
            }
            else {
                this.isResourcesConfirmModalVisible = true;
                this.delete_id = tid;
                this.resource_type = 'tasklists';
                this.cancelBtn = 'Cancel';
                this.confirmation_message = 'This tasklist users will no longer have access';
            }
        },
        resourcesConfirmationAction() {
            this.isConfirmBtn = false;
            this.isYesBtn = true;
            this.confirmation_message = 'Are you sure you want to make this change';
            this.cancelBtn = 'No';
        },
        closeConfirmationAction() {
            if (!this.confirm_all_warnings) {
                if (this.resource_type == 'tasklists') {
                    document.getElementById('tasklist_' + this.delete_id).checked = true;
                    this.tasklistsSelected.push(this.delete_id);
                }
                if (this.resource_type == 'courses') {
                    document.getElementById('course_' + this.delete_id).checked = true;
                    this.coursesSelected.push(this.delete_id);
                }
                if (this.resource_type == 'assessments') {
                    document.getElementById('assessment_' + this.delete_id).checked = true;
                    this.assessmentsSelected.push(this.delete_id);
                }
            }
            this.isResourcesConfirmModalVisible = false;
            this.isConfirmBtn = true;
            this.isYesBtn = false;
            this.cancelBtn = 'Cancel';
            this.confirmation_message = 'This assessments users will no longer have access';
        },
        doUpdateAssignmentAction() {
            if (this.resource_type == 'tasklists') {
                const removeItemIndex = this.tasklistsSelected.indexOf(this.delete_id);
                this.removedTasklists.push(this.delete_id);
                if(removeItemIndex > -1) {
                    this.tasklistsSelected.splice(removeItemIndex, 1); 
                }
            }
            if (this.resource_type == 'courses') {
                const removeItemIndex = this.coursesSelected.indexOf(this.delete_id);
                this.removedCourses.push(this.delete_id);
                if(removeItemIndex > -1) {
                    this.coursesSelected.splice(removeItemIndex, 1); 
                }
            }
            if (this.resource_type == 'assessments') {
                const removeItemIndex = this.assessmentsSelected.indexOf(this.delete_id);
                this.removedAssessments.push(this.delete_id);
                if(removeItemIndex > -1) {
                    this.assessmentsSelected.splice(removeItemIndex, 1); 
                }
            }
            this.confirm_all_warnings = true;
            this.closeConfirmationAction();
        },
        saveResourcesAssignment() {
            this.loading = true;
            axios('/enterprise-admin/resourse-assignment',
            {
                method: 'POST',
                data: {
                    'modified_tasklists': this.modifiedTasklists,
                    'removed_tasklists': this.removedTasklists,
                    'modified_courses': this.modifiedCourses,
                    'removed_courses': this.removedCourses,
                    'modified_assessments': this.modifiedAssessments,
                    'removed_assessments': this.removedAssessments,
                    'account_id': this.accountId,
                }
            })
            .then(response => {
                this.loading = false;
                this.updateMsg = "Resources updated successfully";
                this.modifiedTasklists = [];
                this.modifiedAssessments = [];
                this.modifiedCourses = [];
                this.removedTasklists = [];
                this.removedCourses = [];
                this.removedAssessments = [];
                this.getAccountResources();
            })
            .catch(() => {
            });
        },
        getAccountResources() {
            this.loading = true;
            axios.get('/enteprise-admin/account-details/' + this.accountId, {
            })
            .then(response =>  {
                this.updateMsg = '';
                this.loading = false;
                this.isResponseStatus = true;
                this.accountTaskLists = response.data.tasklists;
                this.accountTaskListsCount = response.data.tasklists.length;
                this.tasklistsSelected = response.data.assigned_tasklists;
                if(this.accountTaskListsCount > 3) {
                    for( var i=0; i< 3; i++) {
                        this.lessAccountTaskLists[i] = response.data.tasklists[i];
                    }
                }
                else {
                    for( var j=0; j< this.accountTaskListsCount; j++) {
                        this.lessAccountTaskLists[j] = response.data.tasklists[j];
                    }
                }
                this.accountCourses = response.data.courses;
                this.accountCoursesCount = response.data.courses.length;
                this.coursesSelected = response.data.assigned_courses;
                if(this.accountCoursesCount > 3) {
                    for( var i=0; i< 3; i++) {
                        this.lessAccountCourses[i] = response.data.courses[i];
                    }
                }
                else {
                    for( var j=0; j< this.accountCoursesCount; j++) {
                        this.lessAccountCourses[j] = response.data.courses[j];
                    }
                }
                this.accountForms = response.data.forms;
                this.accountFormsCount = response.data.forms.length;
                if(this.accountFormsCount > 3) {
                    for( var i=0; i< 3; i++) {
                        this.lessAccountForms[i] = response.data.forms[i];
                    }
                }
                else {
                    for( var j=0; j< this.accountFormsCount; j++) {
                        this.lessAccountForms[j] = response.data.forms[j];
                    }
                }
                this.accountAssessments = response.data.assessments;
                this.accountAssessmentsCount = response.data.assessments.length;
                this.assessmentsSelected = response.data.assigned_assessments;
                if(this.accountAssessmentsCount > 3) {
                    for( var i=0; i< 3; i++) {
                        this.lessAccountAssessments[i] = response.data.assessments[i];
                    }
                }
                else {
                    for( var j=0; j< this.accountAssessmentsCount; j++) {
                        this.lessAccountAssessments[j] = response.data.assessments[j];
                    }
                }
            })
            .catch(function(error) {
                console.log(error);
            });
        }
    },
    created() {
        this.getAccountResources();
    }
}
</script>
<style scoped>
/* resources tab css */
.res_heading_1 { width: 80%; }
.res_heading_2 { width: 20%; }
.res_offcanvas_header { float: left; font-weight: 900; cursor: pointer; margin-top: 15px; }
.res_offcanvas_content { float: left; margin: 5px 0; font-weight: 500; }
.resources_lists { padding: 10px 0; }
.resources_lists:nth-last-child(1):after { border-bottom: 0 none; }
.resources_lists:after {
    content: "";
    display: block;
    width: 95%;
    border-bottom: 1px solid #CCC;
}
.text-green { color: #28a745 !important; font-weight: 900; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.see-more { color: #00acee; font-weight: 900; }
.cancelBtn, .cancelBtn:focus, .cancelBtn:active, .cancelBtn:hover {
  color: #00acee !important; 
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 100px;
  border-radius: 10px;
}
.saveBtn, .saveBtn:focus, .saveBtn:active, .saveBtn:hover {
  color: #FFF !important;
  background: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  width: 100px;
}
.confirm_message { font-size: 1rem; }
/* resources tab css */
.custom_heading_hr,
.custom_hr {
    width: 100%;
    margin: 5px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.custom-control-label::before {
    left: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/resources_tab.vue